module.exports = __webpack_public_path__ + "static/media/7.d78c1f98.jpeg";